//import { ComputeSearchList } from '../../../../models/ComputeSearchList';
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadComputeList';
export const computeListActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const computeListLoadAction = (payload) => {
    return {
        type: computeListActionTypes.LOAD,
        payload: payload,
    };
};
export const computeListLoadingAction = (payload) => {
    return {
        type: computeListActionTypes.LOADING,
        payload: payload,
    };
};
export const computeListLoadedAction = (payload, result) => {
    return {
        type: computeListActionTypes.LOADED,
        payload: {
            items: result,
        },
    };
};
export function setComputeListFunc(items) {
    return {
        type: computeListActionTypes.LOADED,
        payload: {
            items: items,
        },
    };
}
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case computeListActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { items: Object.assign(Object.assign({}, state.items), { status: AsyncRequestStatus.Pending }) });
        case computeListActionTypes.LOADED:
            const loadedAction = action;
            return Object.assign(Object.assign({}, state), { items: loadedAction.payload.items });
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=ComputeList.ducks.js.map
